import React, { useCallback, useMemo, useState } from "react";
import MicroModal from "micromodal";
import Moment from "moment";
import _ from "lodash";
import { endOfDay, isWithinInterval, parse, startOfDay } from "date-fns";

import ModalsDetails from "../../components/modals/NewModals/index";

import { ReactComponent as IconMaximize } from "../../build/images/popover-queue/maximize-icon.svg";
import { ReactComponent as FilterIconNew } from "../../build/images/teams/search-normal-new.svg";
import { ReactComponent as Interacoes } from "../../build/images/popover-queue/people.svg";
import { ReactComponent as Anotacoes } from "../../build/images/popover-queue/edit-2.svg";
import { ReactComponent as MsgFavoritas } from "../../build/images/popover-queue/sms-star.svg";
import { ReactComponent as ArquivosComp } from "../../build/images/popover-queue/direct-send.svg";
import { ReactComponent as AlterarExcluir } from "../../build/images/popover-queue/call-slash.svg";
import { ReactComponent as Transferir } from "../../build/images/popover-queue/redo.svg";

import "./quarentine-zone.styles.css";
import { useDispatch, useSelector } from "react-redux";
import QueueItemV2 from "../QueueItemV2/QueueItemV2";
import {
  addCcontactIdsToQuarentine,
  CloseAttendant,
  desabilitarBotaoAtenderStandby,
  DetailsAnotationsida,
  DetailsFileShared,
  DetailsMarkstarida,
  GetHistory,
  GetInteractionsModal,
  InteracoesContactNumber,
  removeItemFromListQuarentineCallQueue,
} from "../../actions";
import {
  endCallOnQuarentine,
  removeOfQuarentineZone,
} from "../../actions/websocket";
import TransferClientModal from "../../containers/TransferClientModal";
import { AutoSizer, List } from "react-virtualized";

MicroModal.init();

const QuarentineZoneContent = ({
  filteredListQuarentineQueue,
  onClickInFilter = () => { },
}) => {
  const disableStandByButton = useSelector(
    (state) => state.disableStandByButton,
  );
  const dispatch = useDispatch();
  const infoUsers = useSelector(
    (state) => state.informationusers,
    (prev, next) => _.isEqual(prev) === _.isEqual(next),
  );
  const listQuarentineQueue = useSelector(
    (state) => state.listQuarentineQueue.list,
  );
  const [isExpanded, setIsExpanded] = useState(false);
  const [infoToTransfer, setInfoToTransfer] = useState({
    cdrid: "",
    scriptid: "",
    mediaid: "",
    queueId: "",
  });
  const [quarentineInfo, setQuarentineInfo] = useState({
    infoUsers,
    contactId: {},
    standbyId: "",
    cdrId: "",
    idAtendimento: "",
  });
  // const filteredListQuarentineQueue = useMemo(() => {
  //   let updatedFilteredListQuarentineQueue = listQuarentineQueue;
  //   const hasTextToFilter = !!textToFilter;
  //   // if (!hasTextToFilter) {
  //   //   return listQuarentineQueue;
  //   // }
  //   if (hasTextToFilter) {
  //     updatedFilteredListQuarentineQueue = listQuarentineQueue.filter(
  //       (quarentineItem) => {
  //         return quarentineItem.contactName
  //           .toLowerCase()
  //           .includes(textToFilter.toLowerCase());
  //       }
  //     );
  //   }
  //   const hasFiltermediastorage =
  //     !!filtermediastorage &&
  //     Array.isArray(filtermediastorage) &&
  //     filtermediastorage.length > 0;
  //   if (hasFiltermediastorage) {
  //     updatedFilteredListQuarentineQueue =
  //       updatedFilteredListQuarentineQueue.filter((quarentineItem) => {
  //         return filtermediastorage.includes(parseInt(quarentineItem.midiaId));
  //       });
  //   }

  //   const hasInitialAndFinalDate = !!initialDate && !!finalDate;
  //   if (hasInitialAndFinalDate) {
  //     updatedFilteredListQuarentineQueue =
  //       updatedFilteredListQuarentineQueue.filter((quarentineItem) => {
  //         const hasDateTime = !!quarentineItem.dateTime;
  //         if (!hasDateTime) {
  //           return true;
  //         }
  //         const dateOfStandBy = parse(
  //           quarentineItem.dateTime,
  //           "dd/MM/yyyy HH:mm:ss",
  //           new Date()
  //         );
  //         return isWithinInterval(dateOfStandBy, {
  //           start: startOfDay(initialDate),
  //           end: endOfDay(finalDate),
  //         });
  //       });
  //   }

  //   return updatedFilteredListQuarentineQueue;
  // }, [
  //   textToFilter,
  //   listQuarentineQueue,
  //   filtermediastorage,
  //   initialDate,
  //   finalDate,
  // ]);

  const showInteractionsModal = useCallback(
    (phoneNumber) => {
      dispatch(GetHistory([]));
      let now = Moment().subtract(7, "days");
      const histstart = now.format("YYYY-MM-DD") + "T00:00";
      const histend = Moment().format("YYYY-MM-DD") + "T23:59";
      let idgroup = infoUsers.idgroup;
      const number = phoneNumber.substr(2);
      dispatch(
        InteracoesContactNumber(number, histstart, histend, "", idgroup),
      );
      MicroModal.show("modal__historico-atendimento-details");
    },
    [dispatch, infoUsers.idgroup],
  );
  const showAnotationModal = useCallback(
    (phoneNumber) => {
      let erro = 0;
      let now = Moment().subtract(1, "month");
      const datainit = now.format("YYYY-MM-DD");
      const datafim = Moment().format("YYYY-MM-DD");
      const idcriticidade = "";

      let comparation = Moment(datainit).isBefore(datafim);

      if (datainit === "") erro = 1;

      if (datafim === "") erro = 1;

      if (comparation === false) {
        erro = 1;
        if (datainit === datafim) {
          erro = 0;
        }
      }

      if (erro === 0) {
        dispatch(
          DetailsAnotationsida(datainit, datafim, idcriticidade, phoneNumber),
        );
      }
      MicroModal.show("modal__anotacoes-details-new");
    },
    [dispatch],
  );
  const showFavoriteMessagesModal = useCallback(
    (phoneNumber) => {
      let erro = 0;
      let now = Moment().subtract(1, "month");
      const datainit = now.format("YYYY-MM-DD");
      const datafim = Moment().format("YYYY-MM-DD");

      var comparation = Moment(datainit).isBefore(datafim);

      if (datainit === "") erro = 1;

      if (datafim === "") erro = 1;

      if (comparation === false) {
        erro = 1;
        if (datainit === datafim) {
          erro = 0;
        }
      }

      if (erro === 0) {
        dispatch(DetailsMarkstarida(datainit, datafim, phoneNumber));
      }
      MicroModal.show("modal__mensagens-favoritas-details");
    },
    [dispatch],
  );
  const showSharedFilesModal = useCallback(
    (phoneNumber) => {
      let erro = 0;
      let now = Moment().subtract(1, "month");
      const datainit = now.format("YYYY-MM-DD");
      const datafim = Moment().format("YYYY-MM-DD");
      const formats =
        "3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28";
      const midias = "2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18";

      var comparation = Moment(datainit).isBefore(datafim);

      if (datainit === "") erro = 1;

      if (datafim === "") erro = 1;

      if (formats === "") erro = 1;

      if (midias === "") erro = 1;

      if (comparation === false) {
        erro = 1;
        if (datainit === datafim) {
          erro = 0;
        }
      }

      if (erro === 0) {
        dispatch(
          DetailsFileShared(datainit, datafim, formats, midias, phoneNumber),
        );
      }
      MicroModal.show("modal__arquivos-compartilhados-details");
    },
    [dispatch],
  );

  const renderPopover = useCallback(
    (phoneNumber, contactName) => {
      return (
        <ul className="popover-quarentine-zone-content">
          <li
            className="popover-quarentine-zone-content__item"
            onClick={() => {
              dispatch(GetInteractionsModal(contactName, phoneNumber));
              showInteractionsModal(phoneNumber);
            }}
          >
            <Interacoes />
            <span className="popover-quarentine-zone-content__item__text">
              Interações
            </span>
          </li>
          <li
            className="popover-quarentine-zone-content__item"
            onClick={() => {
              dispatch(GetInteractionsModal(contactName, phoneNumber));
              showAnotationModal(phoneNumber);
            }}
          >
            <Anotacoes />
            <span className="popover-quarentine-zone-content__item__text">
              Anotações
            </span>
          </li>
          <li
            className="popover-quarentine-zone-content__item"
            onClick={() => {
              dispatch(GetInteractionsModal(contactName, phoneNumber));
              showFavoriteMessagesModal(phoneNumber);
            }}
          >
            <MsgFavoritas />
            <span className="popover-quarentine-zone-content__item__text">
              Mensagens favoritas
            </span>
          </li>
          <li
            className="popover-quarentine-zone-content__item"
            onClick={() => {
              dispatch(GetInteractionsModal(contactName, phoneNumber));
              showSharedFilesModal(phoneNumber);
            }}
          >
            <ArquivosComp />
            <span className="popover-quarentine-zone-content__item__text">
              Arquivos compartilhados
            </span>
          </li>
        </ul>
      );
    },
    [
      showInteractionsModal,
      showAnotationModal,
      showFavoriteMessagesModal,
      showSharedFilesModal,
    ],
  );
  const renderMoreOptions = useCallback(
    (contactid, standbyId, cdrId, idAtendimento, mediaId) => {
      return (
        <ul className="popover-quarentine-zone-content">
          <li
            className="popover-quarentine-zone-content__item"
            onClick={() => {
              setInfoToTransfer({
                cdrid: cdrId,
                scriptid: "",
                mediaid: mediaId,
                queueId: "",
              });
              setQuarentineInfo({
                infoUsers,
                contactId: contactid,
                standbyId: standbyId,
                cdrId: cdrId,
                idAtendimento: idAtendimento,
              });
              setTimeout(() => {
                MicroModal.show("modal__transferir__chamada");
              }, 100);
            }}
          >
            <Transferir />
            <span className="popover-quarentine-zone-content__item__text">
              Transferir
            </span>
          </li>
          <li
            className="popover-quarentine-zone-content__item"
            onClick={() => {
              endCallOnQuarentine(infoUsers, contactid);
              dispatch(
                removeItemFromListQuarentineCallQueue(
                  standbyId,
                  cdrId,
                  idAtendimento,
                ),
              );
              // dispatch(CloseAttendant(contactid, infoUsers, "encerramento"));
            }}
          >
            <AlterarExcluir />
            <span className="popover-quarentine-zone-content__item__text">
              Excluir chamada
            </span>
          </li>
        </ul>
      );
    },
    [
      dispatch,
      infoUsers,
      setInfoToTransfer,
      setQuarentineInfo,
      endCallOnQuarentine,
    ],
  );
  const handleAnswer = useCallback(
    (
      contactName,
      score,
      classScore,
      pathfile,
      dateTime,
      standbyId,
      phoneNumber,
      mediaId,
      isExpanded,
      contactId,
      cdrId,
      idAtendimento,
      unreadMessages,
    ) => {
      dispatch(
        addCcontactIdsToQuarentine({
          ...contactId,
          score,
          classScore,
          unreadMessagesOfQuarentine: unreadMessages,
        }),
      );
      removeOfQuarentineZone(contactId, infoUsers);
      dispatch(desabilitarBotaoAtenderStandby());
    },
    [dispatch, infoUsers, removeOfQuarentineZone],
  );
  return (
    <div className="quarentine-zone-content">
      {/* <div className="quarentine-zone-content__header">
        <button
          className="quarentine-zone-content__header__maximize-btn"
          onClick={() => {
            setIsExpanded((prevState) => !prevState);
          }}
        >
          <IconMaximize />
          <span>{isExpanded ? "Retrair todos" : "Expandir todos"}</span>
        </button>
        <button
          className="quarentine-zone-content__header__filter-btn"
          onClick={() => {
            onClickInFilter();
          }}
        >
          <FilterIconNew />
        </button>
      </div> */}
      <div className="quarentine-zone-content__body">
        <AutoSizer>
          {({ width, height }) => {
            const cellHeight = isExpanded ? 133 : 85;
            const rowRendered = ({ key, index, style }) => {
              const call = filteredListQuarentineQueue[index];
              return (
                <div key={key} style={style}>
                  <QueueItemV2
                    key={index}
                    contactName={call.contactName}
                    score={call.scoreValue}
                    classScore={call.scoreClass}
                    dateTime={call.dateTime}
                    standbyId={call.standbyId}
                    phoneNumber={call.phoneNumber}
                    mediaId={call.midiaId}
                    isExpanded={isExpanded}
                    contactId={call.contactId}
                    cdrId={call.cdrId}
                    idAtendimento={call.idAtendimento}
                    unreadMessages={call.unreadMessages}
                    isAnswerDisabled={disableStandByButton}
                    renderPopover={renderPopover}
                    renderMoreOptions={renderMoreOptions}
                    onAnswer={handleAnswer}
                  />
                </div>
              );
            };
            return (
              <List
                width={width}
                height={height}
                rowCount={filteredListQuarentineQueue.length}
                rowHeight={cellHeight}
                rowRenderer={rowRendered}
              />
            );
          }}
        </AutoSizer>
      </div>
      <ModalsDetails.NewAnotationModal />
      <ModalsDetails.NewMessageFavoriteModal />
      <ModalsDetails.NewFileShareModal />
      <ModalsDetails.InteractionsHistoricModal />
      <TransferClientModal
        infoQueue={infoToTransfer}
        quarentineInfo={quarentineInfo}
      />
    </div>
  );
};

export default React.memo(QuarentineZoneContent, (prevProps, nextProps) => {
  return (
    prevProps.filteredListQuarentineQueue ===
    nextProps.filteredListQuarentineQueue
  );
});
